import React from 'react';
import { Icon, Text } from '@shopify/polaris';
import { MakePaymentIcon } from '@shopify/polaris-icons';

interface LlmUsageIndicatorProps {
  label?: string;
  tooltipText?: string;
}

export function LlmUsageIndicator({ 
  label,
  tooltipText = 'This operation uses AI and counts towards your monthly LLM usage limit.'
}: Readonly<LlmUsageIndicatorProps>): React.ReactElement {
  return (
    <div title={tooltipText} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', cursor: 'help' }}>
       <Icon source={MakePaymentIcon} tone="magic" />
       {label && <Text as="span" variant="bodySm" tone="subdued">{label}</Text>}
    </div>
  );
}
